import React, { useState, useEffect } from 'react'

export default function SplashScreen({ onDone }) {
    const [animating, setAnimating] = useState(false)

    useEffect(() => {
        const animTimer = setTimeout(() => setAnimating(true), 4000)
        const doneTimer = setTimeout(() => onDone(), 5000)
        return () => {
            clearTimeout(animTimer)
            clearTimeout(doneTimer)
        }
    }, [onDone])

    return (
        <div
            style={{
                position: 'fixed',
                inset: 0,
                zIndex: 9999,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: '#000',
                clipPath: animating ? 'inset(50% 50% 50% 50%)' : 'inset(0% 0% 0% 0%)',
                transition: animating ? 'clip-path 1s ease-in-out' : 'none',
            }}
        >
            <img
                src="/images/bankroll_image.png"
                alt="Bankroll"
                style={{ maxWidth: '720px', width: '80%', height: 'auto' }}
            />
        </div>
    )
}
